// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3Bvxv","description":"PatientConsentPreview_description__2b0ht"};